import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController } from 'ionic-angular';
import { SportsBetslipPage } from '../sports-betslip/sports-betslip';
import { Sportshome, SportsHomeService } from 'baseline-lib';
import { LoginModalPage } from '../../shared/login-modal/login-modal';
import { RegisterModalPage } from '../../shared/register-modal/register-modal';
import { Global } from '../../../global/global';

/**
 * Generated class for the SportsMenuPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-sports-menu',
  templateUrl: 'sports-menu-page.html',
})
export class SportsMenuPage {

  fromBetSlip : any;
  sportsHomeObj: Sportshome;

  constructor(public navCtrl: NavController, public navParams: NavParams,
    private _sportsHomeService: SportsHomeService,public modalCtrl : ModalController,public globalData : Global) {
    this.fromBetSlip = navParams.get('fromBetSlip');
    this.sportsHomeObj = new Sportshome();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SportsMenuPage');
  }

  ngOnInit(){
    //this._sportsHomeService.gameList = [];
    //this._sportsHomeService.setSportsGame();
    this.sportsHomeObj = this._sportsHomeService.sportshomeobj;         
  }

  openBetSlipPage()
  {
    if(this.fromBetSlip == "fromBetSlip")
    {
      this.navCtrl.pop()
    }
    else
    {
      this.navCtrl.push(SportsBetslipPage);
    }
  }

  loginClicked()
  {
    let profileModal = this.modalCtrl.create(LoginModalPage);
    profileModal.present();    
  }

  registerClicked()
  {
    let registerModal = this.modalCtrl.create(RegisterModalPage);
    registerModal.present();
  }

}



// WEBPACK FOOTER //
// ./src/app/sports/sports-menu-page/sports-menu-page.ts